<template>
    <div class="scc-game-content" :class="`scc-game-content--${backgroundColor}`">
        <div v-for="gameContent in filteredGameContent" :key="gameContent.id" class="scc-game-content__item">
            <div v-html="$sanitize(gameContent['title'])"></div>
            <div v-html="$sanitize(gameContent['text'])"></div>
        </div>
    </div>
</template>

<script>
import './game-content.scss';
const colors = ['primary', 'secondary', 'white', 'grey'];

export default {
    name: 'GameContent',
    __editor: {
        requiredData: ['gameContent'],
        fields: {
            gameContentType: {
                widget: 'select',
                values: [
                    { value: 'faq', text: 'Veelgestelde vragen' },
                    { value: 'privacy_policy', text: 'Privacyvoorwaarden' },
                    { value: 'terms_and_conditions', text: 'Spelreglement' },
                ],
            },
            backgroundColor: {
                widget: 'select',
                values: colors,
            },
        },
    },
    props: {
        gameContent: {
            type: Array,
        },
        gameContentType: {
            type: String,
            default: 'faq',
        },
        backgroundColor: {
            type: String,
            required: false,
            default: 'white',
            validator: function(val) {
                return colors.includes(val);
            },
        },
    },
    computed: {
        filteredGameContent() {
            if (!this.gameContent || !this.gameContentType) return [];

            // Filter on gameContentType
            let self = this;
            let filtered = this.gameContent.filter(item => {
                return item.type == self.gameContentType;
            });
            // Sort
            filtered.sort((a, b) => (a.position > b.position ? 1 : b.position > a.position ? -1 : 0));
            return filtered;
        },
    },
};
</script>
